import React from 'react';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

export const ColorDotWithTooltip = ({color, size, tooltip}) => (
  <GenericTooltip positionTop hoverBehavior delay={TOOLTIP_DELAY} tooltip={tooltip}>
    <ColorDot color={color} size={size} />
  </GenericTooltip>
);

export const ColorDot = ({color, size}) => (
  <svg viewBox={'0 0 16 16'} height={size} width={size}>
    <circle r={8} cx={8} cy={8} fill={color} />
  </svg>
);
